const RequestModel = {
  entity_type: "string",
  review_period_start: "string",
  review_period_end: "string",
  requested_leaderships: "array",
}

export default RequestModel
